
const messages = {
    en: {
       delivery: {
          stockTransaction: {
            name: 'StockTransaction',
            title: 'StockTransaction management',
            subtitle: 'View, search, create, edit and delete StockTransaction',
            creating: 'Creating StockTransaction',
            editing: 'Editing StockTransaction',
            deleting: 'Deleting StockTransaction',
            showing: 'Showing StockTransaction',
            menu: 'StockTransaction',
            labels: {
                branch: 'Branch',
                branchDestination: 'Branch Destination',
                destinationBranch: 'Branch Destination',
                operation: 'Operation',
                reason: 'Reason',
                items: 'Items',
                user: 'User',
                createdAt: 'CreatedAt',
                total: 'Total items'

            },

          }
       }
    },
    es: {
       delivery: {
          stockTransaction: {
            name: 'StockTransaction',
            title: 'Administración de StockTransaction',
            subtitle: 'Ver, buscar, crear, editar, y borrar StockTransaction',
            creating: 'Creando StockTransaction',
            editing: 'Modificando StockTransaction',
            deleting: 'Eliminando StockTransaction',
            showing: 'Detalles de StockTransaction',
            menu: 'StockTransaction',
            labels: {
                branch: 'Sucursal',
                branchDestination: 'Sucursal Destino',
                destinationBranch: 'Sucursal Destino',
                operation: 'Operación',
                reason: 'Motivo',
                items: 'Artículos',
                user: 'Usuario',
                createdAt: 'Creado',
                total: 'Total items'
            },

          }
       }
    },
    pt: {
       delivery: {
          stockTransaction: {
            name: 'StockTransaction',
            title: 'Administração de StockTransaction',
            subtitle: 'Ver, buscar, criar, editar e usar StockTransaction',
            creating: 'Criando StockTransaction',
            editing: 'Edição StockTransaction',
            deleting: 'Apagando StockTransaction',
            showing: 'Detalhes do StockTransaction',
            menu: 'StockTransaction',
            labels: {
                branch: 'Branch',
                branchDestination: 'Branch Destination',
                destinationBranch: 'Sucursal Destino',
                operation: 'Operación',
                reason: 'Reason',
                items: 'Items',
                user: 'Usuario',
                createdAt: 'CreatedAt',
                total: 'Total items'
            },

          }
       }
    }
}

export default messages
